import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladNv: [],
		VyrobekvozOzn: [],
		Stanoviste: [],
	},
	filter: {
		SkladnvOzn: null as number | null,
		VyrobekvozOzn: null as string | null,
		Typkod: null as string | null,
		TypkodText: null as string | null,
		KaroserieNrBezM: null as string | null,
		KomiseNr: null as string | null,
		ProvozovnaId: null as number | null,
		PnvNr: null as number | null,
		PrijemDatOd: null as string | null,
		PrijemDatDo: null as string | null,
		PredpoklDatOd: null as string | null,
		PredpoklDatDo: null as string | null,
		Stanovst: null as string | null,
		NvprijemkaNr: null as string | null,
		NvprijemkaPfx: null as string | null,
		DodavdoklNr: null as string | null,
		MarketakceId: null as number | null,
		DodavdoklDatOd: null as string | null,
		DodavdoklDatDo: null as string | null,
		NvSkladId: null as number | null,
		DodavdoklSplatOd: null as string | null,
		DodavdoklSplatDo: null as string | null,
		VProcesuPrijmu: false,
		NaSklade: false,
		Vydano: false,
		MontazDV: false,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {
		[types.mutations.NOVE_VOZY_TYP_KOD_LIST_SELECT_MAPPER](state, { data }: { data: any }) {
			if (!data.isClear) {
				state.filter.VyrobekvozOzn = data.vyrobekvozozn;
			}
			state.filter.Typkod = data.typkod;
			state.filter.TypkodText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
